import ApiClient from "../ApiClient";
import PaymentGroup from "../../models/admin/payment-group/PaymentGroup";

export default class PaymentGroupApiClient {
  apiClient: ApiClient;
  urlPrefix: string = "admin/payment-groups/";

  constructor() {
    this.apiClient = new ApiClient();
  }

  async getAllByTypeAndDate(paymentRequestTypeId: number, date: Date) {
    const groups = await this.apiClient.get(
      this.urlPrefix +
        `?paymentRequestTypeId=${paymentRequestTypeId}&date=${date}`
    );

    return groups as Array<PaymentGroup>;
  }
}
